import React from 'react'
import { useSelector } from 'react-redux'
import { MARKETING_AND_LOGISTICS } from 'constants/forioVariables'
import { CONSTANTS } from 'constants/constants'
import BaseSalesChart from './BaseSalesChart'

const { SALES_1_GL } = CONSTANTS.MARKETING_AND_LOGISTICS
const { CHOCOLATE, STRAWBERRY, LEMON, MANGO, RUM, VANILLA } = CONSTANTS.PRODUCTS

const {
  VENTA_DE_C_SABOR_C,
  VENTA_DE_C_SABOR_F,
  VENTA_DE_C_SABOR_L,
  VENTA_DE_C_SABOR_M,
  VENTA_DE_C_SABOR_R,
  VENTA_DE_C_SABOR_V,
} = MARKETING_AND_LOGISTICS

const flavorsToVariableMapping = {
  [CHOCOLATE]: VENTA_DE_C_SABOR_C,
  [STRAWBERRY]: VENTA_DE_C_SABOR_F,
  [LEMON]: VENTA_DE_C_SABOR_L,
  [MANGO]: VENTA_DE_C_SABOR_M,
  [RUM]: VENTA_DE_C_SABOR_R,
  [VANILLA]: VENTA_DE_C_SABOR_V,
}

const ChartSalesPackageC = () => {
  const variables = useSelector(state => state.marketingAndLogistics.currentValues.salesPackageC)
  return (
    <BaseSalesChart
      title={SALES_1_GL}
      variables={variables}
      flavorsToVariableMapping={flavorsToVariableMapping}
    />
  )
}

export default ChartSalesPackageC
